import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router';
import request from '../../../services/Request';
import MaterialTable from 'material-table';
import { makeStyles } from '@material-ui/core';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import BackButton from '../../items/buttons/BackButton';
import Swal from 'sweetalert2';
import { userLimits } from './../uitls/userLimits';
import DiscountModal from './DiscountModal';
import EditMemberModal from './EditMemberModal';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import HistoryIcon from '@material-ui/icons/History';
import AddShoppingCartModal from './AddShoppingCartModal';
import moment from 'moment';
import AddNewMemberModal from './AddNewMemberModal';
import { ExportToCsv } from 'export-to-csv';
import { CloudDownload } from '@material-ui/icons';

const getAllEmployeesURL = `/clientUser/getClients`;

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(-5.6),
    marginRight: theme.spacing(40),
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

export default function ViewMember(props) {
  const user = JSON.parse(localStorage.getItem('user'));
  const dbaUser = user.dba;
  const classes = useStyles();
  const { id, tableTitle, superAdmin, access } = userLimits(
    props.match.params.id,
    props.match.params.group,
    'Members',
    'edit_member'
  );

  const pinOnlyEmail = ['tianlangwu001@gmail.com', 'shivangum@alpskiosks.com', 'rachel@potere.us'];

  const isPinOnly = pinOnlyEmail.includes(id);

  let history = useHistory();
  const [employees, setEmployees] = useState([]);
  const [reflesh, setReflesh] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [show, setshow] = useState(false);
  const [rowdata, setrowdata] = useState(null);
  const [isMultiple, setIsMultiple] = useState(false);
  const [pagination, setPagination] = useState(
    localStorage.getItem('table_view_member') ? localStorage.getItem('table_view_member') : 10
  );

  const [mobile, setMobile] = useState(false);

  const [showSetting, setShowSetting] = useState(false);
  const [showAddCart, setShowAddCart] = useState(false);
  const [showAddNew, setShowAddNew] = useState(false);

  useEffect(() => {
    localStorage.setItem('table_view_member', pagination);
  }, [pagination]);

  useEffect(() => {
    let isCancelled = false;

    //getAllEmployees
    async function getAllEmployees() {
      await request({
        method: 'post',
        url: getAllEmployeesURL,
        data: {
          id: id,
          dba: dbaUser,
        },
      }).then((res) => {
        if (!isCancelled) {
          console.log('useruser', res.data);
          setEmployees(res.data?.members);
          setMobile(res.data?.mobileSetting);
          setIsLoading(true);
        }
      });
    }

    getAllEmployees();

    return () => {
      isCancelled = true;
    };
  }, [reflesh]);

  const deleteUser = async (id) => {
    await request({
      method: 'delete',
      url: `/deleteClientUser`,
      data: {
        _id: id,
      },
    })
      .then(() => {
        Swal.fire({
          text: `The user has been successfully deleted`,
          icon: 'success',
        });
        reflesh ? setReflesh(false) : setReflesh(true);
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          text: err.response?.data?.error?.message || 'Something went wrong',
          icon: 'error',
        });
      });
  };

  let columns = [
    { title: 'Username', field: 'username', editable: 'never' },
    { title: 'Email', field: 'email', editable: 'never' },
    { title: 'Phone', field: 'phone', editable: 'never' },
    { title: 'Points', field: 'points', editable: 'never' },
    {
      title: 'Last Purchase',
      field: 'last_purchase',
      editable: 'never',
      render: (rowData) =>
        rowData.last_purchase ? moment(rowData.last_purchase).format('MM/DD/YYYY') : '',
    },
    { title: 'Order Count', field: 'order_qtt', editable: 'never' },
  ];

  if (isPinOnly) {
    columns = [
      { title: 'Username', field: 'username', editable: 'never' },
      { title: 'Email', field: 'email', editable: 'never' },
      { title: 'Phone', field: 'phone', editable: 'never' },
      { title: 'Pin', field: 'pin', editable: 'never' },
      {
        title: 'Last Purchase',
        field: 'last_purchase',
        editable: 'never',
        render: (rowData) =>
          rowData.last_purchase ? moment(rowData.last_purchase).format('MM/DD/YYYY') : '',
      },
    ];
  }

  return (
    <div>
      {!isloading && <LoadingIcon />}
      <div style={{ maxWidth: '100%' }}>
        <MaterialTable
          columns={columns}
          data={employees}
          onChangeRowsPerPage={setPagination}
          title={tableTitle}
          localization={{ body: { editRow: { deleteText: 'Are you sure to delete this user' } } }}
          editable={{
            onRowDelete: (newData, oldData) =>
              new Promise((resolve, reject) => {
                setTimeout(() => {
                  deleteUser(newData._id);
                  resolve();
                }, 1000);
              }),
          }}
          actions={[
            {
              icon: 'edit',
              tooltip: 'Setting',
              isFreeAction: true,
              onClick: (event) => {
                if (!access) return Swal.fire('', "You don't have permission", 'error');
                setShowSetting(true);
              },
            },
            {
              icon: `add`,
              tooltip: 'Add new Member',
              isFreeAction: true,
              onClick: (event) => {
                if (!access) return Swal.fire('', "You don't have permission", 'error');
                setShowAddNew(true);
              },
            },
            {
              icon: ShoppingCartIcon,
              tooltip: 'Add Order(All Members)',
              isFreeAction: true,
              onClick: (event) => {
                if (!access) return Swal.fire('', "You don't have permission", 'error');
                setrowdata(null);
                setShowAddCart(true);
              },
            },
            {
              icon: 'edit',
              tooltip: 'Edit Member',
              onClick: (event, rowdata) => {
                if (!access) return Swal.fire('', "You don't have permission", 'error');
                setrowdata(rowdata);
                setshow(true);
              },
            },
            {
              icon: ShoppingCartIcon,
              tooltip: 'Add Order',
              onClick: (event, rowdata) => {
                if (!access) return Swal.fire('', "You don't have permission", 'error');
                setShowAddCart(true);
                setrowdata(rowdata);
              },
            },
            {
              icon: HistoryIcon,
              tooltip: 'Order History',
              onClick: (event, rowdata) => {
                window.open(`/dashboard/memberorder/${rowdata._id}`, '_blank');
              },
            },
            {
              icon: CloudDownload,
              tooltip: 'Download CSV',
              isFreeAction: true,
              onClick: () => {
                // Prepare columns and data for export
                const exportColumns = columns.map((col) => col.title);
                const exportData = employees.map((row) =>
                  columns.map((col) => {
                    let value;
                    if (col.render) {
                      value = col.render(row);
                    } else {
                      value = row[col.field];
                    }
                    // Replace undefined or null with empty string
                    return value === undefined || value === null ? '' : value;
                  })
                );
                const options = {
                  filename: 'Members_csv',
                  fieldSeparator: ',',
                  quoteStrings: '"',
                  decimalSeparator: '.',
                  showLabels: true,
                  useBom: true,
                  headers: exportColumns,
                };
                const csvExporter = new ExportToCsv(options);
                csvExporter.generateCsv(exportData);
              },
            },
          ]}
          options={{
            actionsColumnIndex: -1,
            rowStyle: (rowData) => {
              if (rowData.dba) {
                return {
                  backgroundColor: 'lightblue',
                };
              }
            },
            pageSize: parseInt(pagination),
            pageSizeOptions: [10, 20, 50, 100],
            // exportButton: true, // Remove built-in export button
          }}
        />
        <BackButton />
        <EditMemberModal
          user={user}
          id={id}
          show={show}
          data={rowdata}
          setReflesh={setReflesh}
          reflesh={reflesh}
          onHide={() => {
            setshow(false);
          }}
        />
        <AddShoppingCartModal
          isMultiple={isMultiple}
          user={user}
          id={id}
          show={showAddCart}
          data={rowdata}
          setReflesh={setReflesh}
          reflesh={reflesh}
          onHide={() => {
            setShowAddCart(false);
          }}
        />
        <DiscountModal
          user={user}
          id={id}
          show={showSetting}
          data={mobile}
          setMobile={setMobile}
          setReflesh={setReflesh}
          reflesh={reflesh}
          onHide={() => {
            setShowSetting(false);
          }}
        />
        <AddNewMemberModal
          user={user}
          id={id}
          show={showAddNew}
          setReflesh={setReflesh}
          reflesh={reflesh}
          onHide={() => {
            setShowAddNew(false);
          }}
        />
        <div className={classes.paper}></div>
      </div>
    </div>
  );
}
